import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { shiftDate, periodLabel, periodHorizons } from "@/lib/wellness";
import { cn } from "@/lib/utils";

// Shared reference-date navigator across Day/Week/Month/Quarter/Year + custom date.
export const PeriodNav = ({ horizon, setHorizon, date, setDate, horizons = periodHorizons, testid = "period-nav" }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
    <div className="flex items-center gap-1 rounded-[10px] border border-[color:var(--border-subtle)] bg-white p-1">
      {horizons.map((h) => (
        <button key={h} onClick={() => setHorizon(h)} data-testid={`${testid}-horizon-${h}`}
          className={cn("px-3 py-1.5 rounded-[8px] text-sm transition-colors", horizon === h ? "bg-[var(--green)] text-[#f7fbf9]" : "text-[var(--text-muted)] hover:text-[var(--text)]")}>{h}</button>
      ))}
    </div>
    <div className="flex items-center gap-1 rounded-[10px] border border-[color:var(--border-subtle)] bg-white p-0.5">
      <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => setDate(shiftDate(horizon, date, -1))} data-testid={`${testid}-prev`} aria-label="Previous"><ChevronLeft className="h-4 w-4" /></Button>
      <span className="px-2 text-sm text-[var(--text)] min-w-[150px] text-center" data-testid={`${testid}-label`}>{periodLabel(horizon, date)}</span>
      <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => setDate(shiftDate(horizon, date, 1))} data-testid={`${testid}-next`} aria-label="Next"><ChevronRight className="h-4 w-4" /></Button>
    </div>
    <div className="relative flex items-center">
      <CalendarDays className="h-4 w-4 text-[var(--text-faint)] absolute left-2.5 pointer-events-none" />
      <Input type="date" value={date} onChange={(e) => e.target.value && setDate(e.target.value)} className="w-[150px] pl-8 bg-white border-[color:var(--border-subtle)]" data-testid={`${testid}-custom-date`} />
    </div>
  </div>
);
